/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import {
    BarChart, Bar, XAxis, YAxis, LabelList, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { setCurrencyFormatInWon, colorArray } from '../../../../utils/helpers';

export default function RevenueByCustomerChart({
    dir, dataToPlot, showTitle,
    height, customer  }) {
    const { t } = useTranslation('common');
    const [data, setData] = useState();
    const dataToShow = []
    
    const getRandomColor = () => {
        const letters = '0123456789ABCDEF'.split('');
        let fillColor = '#';
        for (let i = 0; i < 6; i += 1) {
            fillColor += letters[Math.floor(Math.random() * 16)];
        }
        return fillColor;
    }

    return (
        <Col xs={12}>
            <Card >
                <CardBody style={{ marginTop: '50px' }}>
                    {showTitle ? <div className="card__title">
                        <h5 className="bold-text">{t('Category Sales')}</h5>
                    </div> : null}
                    <div dir="ltr">
                        <ResponsiveContainer height={height}>
                            <BarChart
                                data={dataToPlot}
                                margin={{
                                    top: 50, rigth: 0, left: -15, bottom: 0,
                                }}
                            >
                                <XAxis dataKey="day" reversed={dir === 'rtl'} />
                                <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                                    tickFormatter={item => setCurrencyFormatInWon(Number(item).toFixed(2), true)}
                                    width={150}
                                    tick
                                    allowDataOverflow
                                />
                                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                                <Tooltip formatter={value => setCurrencyFormatInWon(Number(value).toFixed(2), true)} />
                                <Legend />
                                <Bar
                                    stackId="a"
                                    fill={getRandomColor()}
                                    // fill="#8884d8"
                                    dataKey="Amount"
                                    stroke="#000000"
                                    name={customer}
                                    barSize={40}
                                ><LabelList dataKey="Amount" formatter={value => setCurrencyFormatInWon(Number(value).toFixed(2), true)} position="top" /></Bar>

                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

RevenueByCustomerChart.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToPlot: PropTypes.arrayOf({}).isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    customer: PropTypes.string,   
}
RevenueByCustomerChart.defaultProps = {
    showTitle: true,
    customer: 'Revenue By Customer'
}
